import { useCallback, useMemo } from 'react';

import { CryptoCore } from '@/shared/lib/secure-json/core/crypto-core';
import { useSJDatabase } from '@/shared/lib/sj-orm/hooks/use-sj-database';
import { useKeyPairStore } from '@/shared/store/decrypted-keypair.store';

import { useFetchFile } from './useFetchFile';

type FileOptions = {
  name?: string;
};

export const useFiles = () => {
  const { keyPair } = useKeyPairStore();
  const sjDatabase = useSJDatabase();
  const { fetchFile } = useFetchFile();

  const decryptDocumentFile = useCallback(
    async (filePath: string, options?: FileOptions) => {
      const fileKey = sjDatabase.collections.encryptedFileKey?.findOne(({ id }) =>
        id.includes(filePath),
      );

      if (fileKey) {
        const fileData = await fetchFile(filePath);

        if (fileData) {
          const symmetricKey = fileKey.symmetricKey;
          const decryptedFile = await CryptoCore.files.decrypt(
            fileData,
            symmetricKey,
            options?.name,
          );

          if (decryptedFile) {
            return decryptedFile;
          } else {
            return undefined;
          }
        } else {
          return undefined;
        }
      }
      return undefined;
    },
    [sjDatabase, keyPair],
  );

  // TODO rework memo is not needed
  return useMemo(() => ({ decryptDocumentFile }), [decryptDocumentFile]);
};
